module.exports = __webpack_public_path__ + "static/img/12.bd83d2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/12.jpg
// module id = k9Nq
// module chunks = 0